var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"module"},[_c('div',{staticClass:"module-list"},[_c('div',{staticClass:"module-item",staticStyle:{"background-color":"#7681F8"}},[_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.productCount))]),_c('div',{staticClass:"name"},[_vm._v("产品总数")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }